import { useEffect, useState } from "react";
import LandingJazzCash from "../components/LandingJazzCash";
import { useParams } from "react-router-dom";
import {
  checkPolicyCheck,
  getMetaDataAndFlowService,
} from "../services/LandingService";
import { NavigateToHome } from "../utils/CommonFunctions";
import { IgetMetaDataAndFlow } from "../@types/ApiResponses";

type Props = {
  token?: string;
};

const LandingJazzCashScreen = (props: Props) => {
  const { planName = "", utmSource = "" } = useParams();
  const [msisdn, setMsisdn] = useState("");
  const [error, setError] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);

  const [planId, setPlanId] = useState<number>(-1);
  const [planData, setPlanData] = useState<IgetMetaDataAndFlow>(
    {} as IgetMetaDataAndFlow
  );

  const [priceState, setPriceState] = useState({
    priceType: "",
    price: "",
  });

  useEffect(() => {
    props.token && getFlow();
  }, [props.token]);

  const getFlow = async () => {
    try {
      let data = {
        pp_config_title: planName,
        utm_source: utmSource,
      };
      let response = await getMetaDataAndFlowService(data);

      if (response.result.jazzCash?.enabled === true) {
        setMsisdn(response.result.msisdn || "");
        setPlanData(response);
        setPlanId(response.result.plan_id);

        setPriceState((prevState: any) => ({
          ...prevState,
          price: response.result.jazzCash?.price,
          priceType: response.result.jazzCash?.interval,
        }));
      } else {
        NavigateToHome();
      }
    } catch (error) {
      console.log("Error in getFlow: ", error);
    }
  };

  const checkPolicy = async () => {
    try {
      setBtnDisable(true);
      const data = {
        msisdn: msisdn,
        plan_id: planId,
      };

      let response = await checkPolicyCheck(data);
      if (response.result === false) {
        window.location.replace(
          `https://fikrfree.com.pk/jcms/link-wallet?msisdn=${msisdn}&plan_id=${planId}&source=WEB&plan_name=${planName}&utm_source=${utmSource}`
        );
      } else {
        setBtnDisable(false);
        setError("You have already subscribed to this plan.");
      }
    } catch (error) {
      setBtnDisable(false);
      setError("Something went wrong. Please try again later.");
      console.log(error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    const input = e.target.value;
    let regex = new RegExp("^(3[0-9]*|)$");

    if (regex.test(input)) {
      setMsisdn(input);
    }
  };

  const handleContinue = () => {
    if (msisdn.length == 10 || msisdn.startsWith("3")) {
      checkPolicy();
    } else {
      setError("Please enter a valid mobile number");
    }
  };

  return (
    <LandingJazzCash
      planData={planData}
      error={error}
      msisdn={msisdn}
      handleChange={handleChange}
      btnDisable={btnDisable}
      handleContinue={handleContinue}
      priceState={priceState}
    />
  );
};

export default LandingJazzCashScreen;
